const KEY = 'hamssah_v2_token';
const LEGACY_KEY = 'hamssah_v2_refresh';

function migrateLegacyTokensOnce(): void {
  const legacyAccess = localStorage.getItem(KEY);
  const legacyRefresh = localStorage.getItem(LEGACY_KEY);
  if (!legacyAccess && !legacyRefresh) return;
  if (legacyAccess && !sessionStorage.getItem(KEY)) {
    sessionStorage.setItem(KEY, legacyAccess);
  }
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
}

migrateLegacyTokensOnce();

export function getToken(): string | null {
  return sessionStorage.getItem(KEY);
}

export function setAccessToken(access: string) {
  sessionStorage.setItem(KEY, access);
}

/** @deprecated refresh token lives in httpOnly cookie — kept for call-site compat */
export function setTokens(access: string, _refresh?: string) {
  setAccessToken(access);
}

export function setToken(t: string) {
  setAccessToken(t);
}

export function clearTokens() {
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem('hamssah_admin_user_snapshot');
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
}
